/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Helpful_Witty_Bison_ScoldInputs */

const en_helpful_witty_bison_scold = /** @type {(inputs: Helpful_Witty_Bison_ScoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Long`)
};

/**
* | output |
* | --- |
* | "Long" |
*
* @param {Helpful_Witty_Bison_ScoldInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const helpful_witty_bison_scold = /** @type {((inputs?: Helpful_Witty_Bison_ScoldInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Helpful_Witty_Bison_ScoldInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_helpful_witty_bison_scold(inputs)
});